import React, { useState, useEffect } from "react";
import TaiSanApi from "../../../../service/taiSanApi";

export const TaiSanThanhLyKhongHopDong = ({ taiSanId }) => {
  useEffect(() => {
    DanhSachTaiSanCamCo();
    return () => {
      UpdateDataTaiSanCamCo({}); // This worked for me ** fix: To fix, cancel all subscriptions and asynchronous tasks in a use Effect cleanup function
    };
  }, []);

  const dataInit = {
    Code: "",
    Note: "",
  };
  const [dataTaiSanCamCo, UpdateDataTaiSanCamCo] = useState(dataInit);
  const DanhSachTaiSanCamCo = () => {
    TaiSanApi.getDetail({ taiSanId }).then((response) => {
      UpdateDataTaiSanCamCo(response.data.ThongTinTaiSan);
    });
  };

  return (
    <>
      <div className="table-responsive table-2">
        <table className="table table-bordered mb-0">
          <thead>
            <tr className="header-v2">
              {/* <th>STT</th> */}
              <th>Mã tài sản</th>
              <th>Ghi chú</th>
              <th className="text-right">Phí kho</th>
            </tr>
          </thead>
          <tbody>
            <tr className="active">
              {/* <th scope="row">1</th> */}
              <td>{dataTaiSanCamCo.Code}</td>
              <td>{dataTaiSanCamCo.Note}</td>
              <td className="text-right">0</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
